export default __webpack_public_path__ + "static/media/app-site-icon.f0a2fb9d.jpg";